"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statistics = exports.card = void 0;

var _oxygenConstants = require("@8x8/oxygen-constants");

var card = {
  cardHeight: '252px',
  cardWidth: '328px',
  cardBackground: _oxygenConstants.color.white,
  cardBoxShadow: "".concat(_oxygenConstants.size.shadowMedium, " ").concat(_oxygenConstants.color.cloudyBlue300),
  cardBorderTop: "6px solid ".concat(_oxygenConstants.color.celadonBlue),
  cardBorderRadius: "".concat(_oxygenConstants.size.borderRadiusMedium, " ").concat(_oxygenConstants.size.borderRadiusMedium, " 0 0"),
  cardHeaderFontWeight: _oxygenConstants.font.weightAttention,
  cardHeaderFontSize: _oxygenConstants.font.sizeMd,
  cardHeaderLineHeight: _oxygenConstants.font.lineHeightSm,
  cardHeaderColor: _oxygenConstants.color.pickledBluewood800,
  cardSeparatorBackgroundColor: _oxygenConstants.color.cloudyBlue300,
  cardSeparatorHeight: '1px',
  cardSeparatorWidth: '100%'
};
exports.card = card;
var statistics = {
  numbersFontWeight: _oxygenConstants.font.weightAttention,
  numbersFontSize: _oxygenConstants.font.sizeMd,
  numbersLineHeight: _oxygenConstants.font.lineHeightMd,
  numbersColorError: _oxygenConstants.color.coral,
  textFontSize: _oxygenConstants.font.sizeXs,
  textLineHeight: _oxygenConstants.font.lineHeightXs,
  textColor: _oxygenConstants.color.steel700,
  textColorError: _oxygenConstants.color.coral,
  boxMargin: "".concat(_oxygenConstants.spacing.md, " ").concat(_oxygenConstants.spacing.lg, " ").concat(_oxygenConstants.spacing.lg),
  boxWidth: '70px'
};
exports.statistics = statistics;